/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Hand_Off_ProtocolsInputs */

const en_svchip_hand_off_protocols = /** @type {(inputs: Svchip_Hand_Off_ProtocolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hand-off protocols`)
};

const ar_svchip_hand_off_protocols = /** @type {(inputs: Svchip_Hand_Off_ProtocolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بروتوكولات التسليم`)
};

const bn_svchip_hand_off_protocols = /** @type {(inputs: Svchip_Hand_Off_ProtocolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`হ্যান্ড-অফ প্রোটোকল`)
};

const de_svchip_hand_off_protocols = /** @type {(inputs: Svchip_Hand_Off_ProtocolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übergabeprotokolle`)
};

const es_svchip_hand_off_protocols = /** @type {(inputs: Svchip_Hand_Off_ProtocolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protocolos de traspaso`)
};

const fr_svchip_hand_off_protocols = /** @type {(inputs: Svchip_Hand_Off_ProtocolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protocoles de transfert`)
};

const pt_svchip_hand_off_protocols = /** @type {(inputs: Svchip_Hand_Off_ProtocolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protocolos de transferência`)
};

const zh_svchip_hand_off_protocols = /** @type {(inputs: Svchip_Hand_Off_ProtocolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换协议`)
};

const tr_svchip_hand_off_protocols = /** @type {(inputs: Svchip_Hand_Off_ProtocolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devir protokolleri`)
};

const ru_svchip_hand_off_protocols = /** @type {(inputs: Svchip_Hand_Off_ProtocolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Протоколы переключения`)
};

const pl_svchip_hand_off_protocols = /** @type {(inputs: Svchip_Hand_Off_ProtocolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protokoły przekazania`)
};

/**
* | output |
* | --- |
* | "Hand-off protocols" |
*
* @param {Svchip_Hand_Off_ProtocolsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_hand_off_protocols = /** @type {((inputs?: Svchip_Hand_Off_ProtocolsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Hand_Off_ProtocolsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_hand_off_protocols(inputs)
	if (locale === "bn") return bn_svchip_hand_off_protocols(inputs)
	if (locale === "de") return de_svchip_hand_off_protocols(inputs)
	if (locale === "es") return es_svchip_hand_off_protocols(inputs)
	if (locale === "fr") return fr_svchip_hand_off_protocols(inputs)
	if (locale === "pt") return pt_svchip_hand_off_protocols(inputs)
	if (locale === "zh") return zh_svchip_hand_off_protocols(inputs)
	if (locale === "tr") return tr_svchip_hand_off_protocols(inputs)
	if (locale === "ru") return ru_svchip_hand_off_protocols(inputs)
	if (locale === "pl") return pl_svchip_hand_off_protocols(inputs)
	return en_svchip_hand_off_protocols(inputs)
});